import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { API_VERSION, BASE_URL } from './constants';

type ApiResponse<T> = {
  success: boolean;
  code: number;
  data?: T;
  message?: any;
};

type Request = <T = boolean>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig,
) => Promise<ApiResponse<T>>;

export const httpClientDefaultHeaders = {
  'api-version': API_VERSION,
};

export const httpClient = axios.create({
  baseURL: BASE_URL,
  headers: httpClientDefaultHeaders,
});

export class Core {
  private httpClient: AxiosInstance;

  constructor() {
    this.httpClient = httpClient;
  }

  get: Request = async (url, params, config) =>
    this.httpClient.get(url, config ? { ...config, params } : { params });

  put: Request = async (url, data, config) =>
    this.httpClient.put(url, data, config);

  patch: Request = async (url, data, config) =>
    this.httpClient.patch(url, data, config);

  post: Request = async (url, data, config) =>
    this.httpClient.post(url, data, config);

  delete: Request = async (url, data) => this.httpClient.delete(url, { data });
}
